import AutomaticAuthorization from ".";

export const automaticAuthorizationRoutes = [
  {
    path: "/automaticAuthorization",
    element: <AutomaticAuthorization />,
  },
];
